module.exports = __webpack_public_path__ + "static/media/directcc_directcc.7032bfd4.ico";